import { formatDateNoTimezone, formatDateTime } from "@/lib/utils";

export function formatHistoryActorLine({
  when,
  actor,
  fallbackActor,
  extra,
  dateOnly = false,
}: {
  when?: string | null;
  actor?: string | null;
  fallbackActor?: string | null;
  extra?: string | null;
  dateOnly?: boolean;
}): string {
  const formatted = dateOnly
    ? formatDateNoTimezone(when)
    : formatDateTime(when);
  const time = formatted || "—";
  const who = actor?.trim() || fallbackActor?.trim() || "";
  const suffix = extra?.trim() ? ` — ${extra.trim()}` : "";
  return `${time}${who ? ` by ${who}` : ""}${suffix}`;
}

/** One labeled history row: timestamp plus the user who performed it. */
export function HistoryActorRow({
  label,
  when,
  actor,
  fallbackActor,
  extra,
  dateOnly = false,
}: {
  label: string;
  when?: string | null;
  actor?: string | null;
  fallbackActor?: string | null;
  extra?: string | null;
  dateOnly?: boolean;
}) {
  return (
    <div>
      <p className="text-muted-foreground">{label}</p>
      <p>
        {formatHistoryActorLine({
          when,
          actor,
          fallbackActor,
          extra,
          dateOnly,
        })}
      </p>
    </div>
  );
}
